import { useAuth } from '../context/AuthContext'
import { Navigate } from 'react-router-dom'
import { PacmanLoader } from 'react-spinners'

const ProtectedRoute = ({children}) => {
  const { user, loadingUser } = useAuth()

  if (loadingUser) return <PacmanLoader cssOverride={{margin: '0 auto', marginTop: '1rem'}}/>

  if (!user) return  <Navigate to='/login' />

  return <>{children}</>
}

export default ProtectedRoute